import {css} from '@emotion/react';
import {useTheme} from '@mui/material';
import {
  ConfigObjectType,
  GetStylesFunction,
  StateId,
  mixins,
} from '@wallaby-ui/core';
import * as React from 'react';

import {MuiFilterNodeContainer} from './MuiFilterNodeContainer';
import {FilterSchema} from 'src/js/model/filters_config';

interface OwnProps {
  caseType?: number | string;
  config: ConfigObjectType;
  filteringStateId: StateId;
  filterAndSearchStateId: StateId;
  serviceUrls: Record<string, any>;
  schema: FilterSchema;
}

type Props = OwnProps;

export const MuiFilterBox: React.FC<Props> = (props) => {
  const {
    caseType,
    config,
    filterAndSearchStateId,
    filteringStateId,
    schema,
    serviceUrls,
  } = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    // TODO: STYLE
    <div css={styles.filterBox}>
      {schema.getResultGroups() &&
        schema.getResultGroups().map((filterGroup) => {
          // filter groups by view
          const filtersByView = filterGroup.getFiltersByView(caseType);
          // show only non-empty groups
          return filtersByView.length > 0 ? (
            <div key={filterGroup.id} css={styles.filterBoxContent}>
              {filtersByView.map((filter) => (
                <MuiFilterNodeContainer
                  key={filter.id}
                  config={config}
                  searchServiceUrl={serviceUrls.searchServiceUrl}
                  filterAndSearchStateId={filterAndSearchStateId}
                  filteringStateId={filteringStateId}
                  node={schema.getFilter(filter.id)}
                  level={-1}
                  schema={schema}
                />
              ))}
            </div>
          ) : null;
        })}
    </div>
  );
};

MuiFilterBox.displayName = 'MuiFilterBox';

const getStyles: GetStylesFunction = (options) => ({
  filterBox: css`
    ${mixins.dlFlexBoxContainerInContainer};
    order: 1;
    overflow: hidden;
    background-color: var(--dlBackgroundPanelColor);
    font-size: var(--dlFontSizeEnlarged);
  `,
  filterBoxContent: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 10px;
  `,
});
